import EventCard from './EventCard';
import EventsList from './EventsList';
import EventPage from './EventPage';
import ServicePage from './ServicePage';

export default {
  EventCard,
  EventsList,
  EventPage,
  ServicePage,
}


// WEBPACK FOOTER //
// ./src/modules/events/components/index.js